import React from 'react';

interface Props {
  triggerMode: (mode: string) => void,
  mode: string
}

const ExportModeOcularisButtons: React.FC<Props> = ({triggerMode, mode}) => {
  return (
    <>
      <div className={mode === 'avi' ? 'export-button active' : 'export-button'}
           onClick={() => triggerMode('avi')}>
        <div>Export AVI</div>
      </div>
      <div className={mode === 'bookmarks' ? 'export-button active' : 'export-button'}
           onClick={() => triggerMode('bookmarks')}>
        <div>Create bookmarks</div>
      </div>
    </>
  )
};

export default ExportModeOcularisButtons